import React from 'react';
import SubtleBadge from 'components/common/SubtleBadge';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheck, faTimes, faQuestionCircle } from '@fortawesome/free-solid-svg-icons';

const StatusBadge = ({ status }) => {
    const value = status?.toLowerCase();

    const statusConfig = {
        active: {
            bg: "#d9f8eb",
            color: "#00894f",
            icon: faCheck
        },
        inactive: {
            bg: "#fde6d8",
            color: "#ac5a2b",
            icon: faTimes
        },
    };

    const config = statusConfig[value] || {
        bg: "#f8f9fa",
        color: "#000",
        icon: faQuestionCircle
    };

    return (
        <SubtleBadge
            pill
            style={{
                backgroundColor: config.bg,
                color: config.color,
                border: `1px solid ${config.color}20`,
                width: "110px",
            }}
            className="d-flex flex-center fs-12 p-2 gap-1"
        >
            <FontAwesomeIcon
                icon={config.icon}
                transform="shrink-2"
                className="ms-1 me-1"
            />
            {status ? status.charAt(0).toUpperCase() + status.slice(1) : "-"}
        </SubtleBadge>
    );
};

export default StatusBadge;
